import { connectToLanguages } from '../../utils/connect';
import { TranslatableTextField } from './TranslatableTextField';

const ConnectedTranslatableTextField = connectToLanguages(TranslatableTextField);

export { ConnectedTranslatableTextField as TranslatableTextField };
